import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Button, ButtonTheme } from 'components/Button';
import { Card } from 'components/Card';
import { ICONS } from 'components/Icon';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { PageScrollView } from 'components/Page';
import { PageEmpty } from 'components/PageEmpty';
import { useScreenSize } from 'hooks/useScreenSize';
import { useSelector } from 'hooks/useSelector';
import { ScreenSize } from 'lib/constants';
import React from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { REMOTE_ASESETUP_FOLDEROPEN } from 'store/actions';
import { selectAseSetupLibraryFolderList } from 'store/remote/selectors';
import { FolderListFolderListItem } from './ListItems/FolderListFolderListItem';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASSESSMENTSETUPLIBRARYEXPLORER],
  Screens.ASSESSMENTSETUPLIBRARYEXPLORERFOLDERS
>;

export const FoldersListScreen: React.FC<Props> = ({ navigation }) => {
  const dispatch = useDispatch();
  const screenSize = useScreenSize();

  const folders = useSelector(selectAseSetupLibraryFolderList);

  const renderItem = React.useCallback(
    (
      item: ReturnType<typeof selectAseSetupLibraryFolderList>[number],
    ): React.ReactNode => (
      <FolderListFolderListItem
        key={item.id}
        id={item.id}
        sectionCount={item.sectionCount}
        questionCount={item.questionCount}
        checklistCount={item.checklistCount}
        onPress={() =>
          navigation.navigate(Screens.ASSESSMENTSETUPLIBRARYEXPLORERSECTIONS, {
            id: item.id,
          })
        }
      />
    ),
    [navigation],
  );

  const handleCreateFolder = () =>
    dispatch(REMOTE_ASESETUP_FOLDEROPEN({ id: undefined }));

  return (
    <PageScrollView
      isInModal={false}
      header={
        <NavigationHeader
          heading="Checklists & Questions"
          subheading="Folders"
          onPressBackButton={
            screenSize === ScreenSize.small ? navigation.goBack : undefined
          }
          menuRight={{
            iconButtonConfig: {
              icon: ICONS.EllipsisLight,
            },
            options: [
              {
                text: 'New Folder',
                onPress: handleCreateFolder,
                icon: ICONS.PlusLight,
              },
            ],
          }}
        />
      }
      emptyChild={
        <PageEmpty
          icon={ICONS.RBPlectrumLight}
          button={{ text: 'New Folder', onPress: handleCreateFolder }}
        />
      }
    >
      {!!folders.length && (
        <>
          <Card>{folders.map(renderItem)}</Card>
          <View style={{ alignItems: 'center' }}>
            <Button
              text="New Folder"
              buttonTheme={ButtonTheme.themeless}
              compact
              onPress={handleCreateFolder}
            />
          </View>
        </>
      )}
    </PageScrollView>
  );
};
